import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import LocationOnOutlined from '@material-ui/icons/LocationOnOutlined';
import moment from 'moment';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table';
import Progress from '../ui/react-ui/progress.jsx'; // api

import { getTrafficEventListPublished } from '../../api/eventAPI'; // redux

import { setTrafficEventTableData, setTrafficEventMarkersSort, setOpenDialog, setDialogContent, setMapCenter, setMapZoom } from '../../redux/traffic-dashboard';
var t = i18n.getFixedT(null, 'traffic-dashboard');
var TrafficEventTable = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      isMobileDevice = _useSelector.app.isMobileDevice,
      _useSelector$envCfg = _useSelector.envCfg,
      contextRoot = _useSelector$envCfg.contextRoot,
      gisMapZoomLevelMax = _useSelector$envCfg.gisMapZoomLevelMax,
      _useSelector$trafficD = _useSelector.trafficDashboard,
      trafficEventTableData = _useSelector$trafficD.trafficEventTableData,
      trafficEventMarkersSort = _useSelector$trafficD.trafficEventMarkersSort,
      eventTypeList = _useSelector$trafficD.eventTypeList;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      eventList = _useState2[0],
      setEventList = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedEventType = _useState4[0],
      setSelectedEventType = _useState4[1];

  var isMounted = useRef(false);
  var isShowEventTable = props.isShowEventTable;
  useEffect(function () {
    if (isMounted.current) {
      getTrafficEventListPublished(contextRoot, false, '', trafficEventMarkersSort, 0, null).then(function (result) {
        var now = moment().valueOf();

        var eventData = _.filter(result.content, function (el) {
          if (_.isEmpty(el.endTime)) return true;
          var endTime = moment(el.endTime).valueOf();
          return endTime > now;
        });

        eventData = selectedEventType ? _.filter(eventData, function (el) {
          return el.typeId === selectedEventType;
        }) : eventData;

        var events = _.map(eventData, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: index + 1
          });
        });

        setEventList(events); // dispatch(setTrafficEventTableData(events))
      });
    }
  }, [JSON.stringify(trafficEventMarkersSort)]);
  useEffect(function () {
    if (!isMounted.current) return;

    if (!selectedEventType) {
      setEventList(trafficEventTableData);
      return setTimeout(function () {
        return Progress.done();
      }, 500);
    }

    var newData = _.filter(_.cloneDeep(trafficEventTableData), function (el) {
      return el.typeId === selectedEventType;
    });

    _.map(newData, function (el, index) {
      el.sequence = index + 1;
    });

    setEventList(newData);
    setTimeout(function () {
      return Progress.done();
    }, 500);
  }, [selectedEventType]);
  useEffect(function () {
    setEventList(trafficEventTableData);
  }, [JSON.stringify(trafficEventTableData)]);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
    return function () {
      setEventList([]);
      setSelectedEventType('');
    };
  }, []);

  var handleSort = function handleSort(sort) {
    dispatch(setTrafficEventMarkersSort(sort));
  };

  var handleSplitTime = function handleSplitTime(time) {
    if (_.isEmpty(time)) return time;
    var timeAry = time.split(' ');
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, timeAry[0]), /*#__PURE__*/React.createElement("div", null, timeAry[1]));
  };

  var handleCenterChange = function handleCenterChange(data) {
    dispatch(setMapCenter({
      lat: data.latitude,
      lng: data.longitude
    }));
    dispatch(setMapZoom(gisMapZoomLevelMax));
  };

  var handleOpenDialog = function handleOpenDialog(data) {
    dispatch(setOpenDialog(true));
    dispatch(setDialogContent(data));
  };

  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'eventContent', {
    label: t('lbl-event-content'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        title: row.location + '\r' + row.description,
        onClick: function onClick() {
          return handleOpenDialog(row);
        }
      }, /*#__PURE__*/React.createElement("div", null, row.location), /*#__PURE__*/React.createElement("div", null, row.description));
    }
  });

  _.set(fields, 'location', {
    label: t('lbl-location'),
    formatter: function formatter(val, row) {
      if (row.latitude === '' || row.longitude === '') return null;
      return /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return handleCenterChange(row);
        }
      }, /*#__PURE__*/React.createElement(LocationOnOutlined, null));
    }
  });

  _.set(fields, 'beginTime', {
    label: t('lbl-released-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    className: cx('trafficEvent-table', {
      'mobile-event-table': isMobileDevice,
      'hideTable': !isShowEventTable
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-terminal-traffic-event')), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-select-all-event-type'),
    list: eventTypeList,
    value: selectedEventType,
    onChange: function onChange(val) {
      Progress.startSpin();
      setSelectedEventType(val);
    },
    width: "180px"
  })), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt dataTable-wrap"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: eventList,
    sort: trafficEventMarkersSort,
    onSort: handleSort
  })));
});
export default TrafficEventTable;